import React from "react";
import TopNavigation from "../../components/TopNavigation";
import UsersBoard from "./Usersboard";
import { Base } from "../../components/RootLayout";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import "./style.scss";

const BlockList = (props) => {
  return (
    <Base>
      <TopNavigation
        titlePage="Blocked User"
        toPath={PageRoutes.setting}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div>
        <div className="content-leaderboard">
          <UsersBoard />
        </div>
      </div>
    </Base>
  );
};

export default BlockList;
